import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Project } from '../objects/project';
import { CargoSpacesSummaryService } from './cargo-spaces-summary.service';

@Injectable({
  providedIn: 'root',
})
export class SaveProjectService {
  constructor(
    private translate: TranslateService,
    private datePipe: DatePipe,
    private cargoSpacesSummaryService: CargoSpacesSummaryService,
  ) {}

  public generateForm() {
    return new UntypedFormGroup({
      name: new UntypedFormControl(this.generateDefaultProjectName(), [
        Validators.required,
        Validators.maxLength(255),
      ]),
      note: new UntypedFormControl('', [Validators.maxLength(500)]),
    });
  }

  public generateVisibleDescription() {
    const workspaceSummary = this.cargoSpacesSummaryService.calculateWorkSpacesSummary();
    return `${this.translate.instant('ldm_taken') as string}: ${workspaceSummary.takenLdm},
      ${this.translate.instant('ldm_free') as string}: ${workspaceSummary.freeLdm}`;
  }

  public generateDefaultProjectName(): string {
    return (
      this.translate.instant('project_from') as string +
      ': ' +
      this.datePipe.transform(Date.now(), 'yyyy-MM-dd')
    );
  }

  public generateProjectDescription(project?: Project) {
    const workspaceSummary = this.cargoSpacesSummaryService.calculateWorkSpacesSummary(project);
    const jsonString = `{
      "ldm": "${workspaceSummary.takenLdm}",
      "freeLdm": "${workspaceSummary.freeLdm}"
    }`;
    return jsonString;
  }
}

export interface SaveProjectFormModel extends UntypedFormGroup {
  value: {
    name: string;
    note: string;
    saveOption?: boolean;
  };
}
